// Built-in playlists shipped as static assets under `public/` and fetched on
// demand (so the ~1MB chord data never bloats the initial JS bundle). The raw
// files are `irealb://` links parsed by the existing iReal Pro engine.

export interface BundledPlaylist {
  id: string;
  /** What the screen calls the list. */
  name: string;
  /** The name the file itself carries (an iReal Pro link ends with its list's
   * name), which the screen never shows: the collection is borrowed, and its
   * name means nothing to a player (user ruling, Oct 2026). */
  fileName: string;
  /** Path under the deploy base (no leading slash); see `fetchBundledPlaylist`. */
  file: string;
}

export const BUNDLED_PLAYLISTS: BundledPlaylist[] = [
  { id: 'jazz-1460', name: 'Chord charts', fileName: 'Jazz 1460', file: 'playlists/jazz-1460.txt' },
];

/** A loaded list's name as the screen shows it: a bundled list by its own
 * name, whatever its file calls it; any other list as it calls itself. */
export function playlistDisplayName(name: string | undefined): string | undefined {
  return BUNDLED_PLAYLISTS.find((list) => list.fileName === name)?.name ?? name;
}

/** Fetch a bundled playlist's raw `irealb://` source, honouring the deploy base
 * (`/voice-leading-calculator/` in production, `/` under VITE_BASE). */
export async function fetchBundledPlaylist(entry: BundledPlaylist): Promise<string> {
  const res = await fetch(import.meta.env.BASE_URL + entry.file);
  if (!res.ok)
    throw new Error(`Could not load the ${entry.name.toLowerCase()} (HTTP ${res.status}).`);
  return (await res.text()).trim();
}
